const appConfig = {
  "name": "mitid-v2",
  "version": "0.1.0",
  "stage": "prod",
  "deployThisBuild": false,
  "okta": {
    "issuer": "https://okta.mit.edu/oauth2/aus6sh93rjqnQuszg697",
    "clientId": "5ceg3m6a939ofpnite9uu7q3el",
    "redirectUris": [
      "https://mitid.mit.edu",
      "https://mitid-web.mit.edu",
      "https://mitid.atlas-apps.mit.edu",
      "https://mitid-mr.atlas-apps.mit.edu"
    ],
    "postLogoutRedirectUris": [
      "https://mitid.mit.edu/logout",
      "https://mitid-web.mit.edu/logout",
      "https://mitid.atlas-apps.mit.edu/logout",
      "https://mitid-mr.atlas-apps.mit.edu/logout"
    ],
    "scopes": [
      "address",
      "email",
      "mit:user:all.manage",
      "mit:user:all.read",
      "mit:user:mitid.manage",
      "offline_access",
      "openid",
      "phone",
      "profile"
    ]
  },
  "amplify": {
    "userPoolId": "us-east-1_bCu6BU8d2",
    "userPoolWebClientId": "5ceg3m6a939ofpnite9uu7q3el",
    "oauth": {
      "domain": "atlas-auth.mit.edu",
      "scope": [
        "digital-id/search",
        "digital-id/user",
        "mitid/user",
        "openid",
        "profile"
      ],
      "redirectUris": [
        "https://mitid.mit.edu",
        "https://mitid-web.mit.edu",
        "https://mitid.atlas-apps.mit.edu",
        "https://mitid-mr.atlas-apps.mit.edu"
      ],
      "postLogoutRedirectUris": [
        "https://mitid.mit.edu/logout",
        "https://mitid-web.mit.edu/logout",
        "https://mitid.atlas-apps.mit.edu/logout",
        "https://mitid-mr.atlas-apps.mit.edu/logout"
      ],
      "responseType": "token",
      "options": {
        "AdvancedSecurityDataCollectionFlag": false
      }
    }
  }
};
export default appConfig;